/**
 * Notes Page
 */

export function Notes() {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-[#2F353D] mb-4">Notes</h1>
      <p className="text-gray-600">Manage your notes</p>
    </div>
  );
}
